import { connect, mapProps } from '@formily/react';
import { CnCheckbox as UiCnCheckbox, CnCheckboxGroup as UiCnCheckboxGroup, } from '@/components/cn-checkbox';
import { mapSize } from '@/form/__builtins__';
export const CnCheckbox = connect(UiCnCheckbox, mapProps(mapSize));
CnCheckbox.displayName = 'CnCheckbox';
export const CnCheckboxGroup = connect(UiCnCheckboxGroup, mapProps({
    dataSource: true,
}, mapSize));
CnCheckboxGroup.displayName = 'CnCheckboxGroup';
